





import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "ui-tab-item"
})
export default class UITabItemComponent extends Vue {
  @Prop({ default: null, type: String })                  title!: String;
  @Prop({ default: false, type: Boolean })           isDisabled!: boolean;
  @Prop({ default: "" })                                 prefix!: "";
  @Prop({ default: "" })                                 suffix!: "";
  @Prop({ default: false, type: Boolean })               active!: boolean;

aciveLocal: boolean = this.active;

  setActive(value: boolean) {
    this.aciveLocal = value;
  }

  setTitle() {
    return this.title;
  }
  header() {
    var title = this.title == null ? "" : this.title;
    return this.prefix +  title + this.suffix;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-tabs/src/ui-tab-item.vue